import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSupport = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 2C13.2333 2 14.3956 2.2379 15.4873 2.71289C16.579 3.18789 17.5329 3.83372 18.3496 4.65039C19.1663 5.46706 19.8121 6.42103 20.2871 7.5127C20.7621 8.60436 21 9.76667 21 11V21C21 21.55 20.8038 22.0204 20.4121 22.4121C20.0204 22.8038 19.55 23 19 23H12V21H19V20H15V12H19V11C19 9.06667 18.3169 7.41647 16.9502 6.0498C15.5835 4.68314 13.9333 4 12 4C10.0667 4 8.41647 4.68314 7.0498 6.0498C5.68314 7.41647 5 9.06667 5 11V12H9V20H5C4.45 20 3.97956 19.8038 3.58789 19.4121C3.19622 19.0204 3 18.55 3 18V11C3 9.76667 3.2379 8.60436 3.71289 7.5127C4.18789 6.42103 4.83372 5.46706 5.65039 4.65039C6.46706 3.83372 7.42103 3.18789 8.5127 2.71289C9.60436 2.2379 10.7667 2 12 2Z",
		fill: "#8D8D92"
	})
});
export default SvgSupport;
